import { Box } from '@mui/material';
import type { FieldMode } from '../../hooks/useCaseField';
import { CaseTextField } from '../fields';

interface NotesSectionProps {
  mode: FieldMode;
}

const NotesSection: React.FC<NotesSectionProps> = ({ mode }) => (
  <Box sx={{ mb: 2.5 }}>
    <CaseTextField mode={mode} label="" fullWidth multiline minRows={3} maxRows={8}
      getValue={d => d.notes ?? ''} getUpdate={v => ({ notes: v })} />
  </Box>
);

export default NotesSection;